export {default} from '../../../core/components/Repository/FieldSwitchJoin';